var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTooltip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21a8.5 8.5 0 110-17 8.5 8.5 0 010 17zm-.975-6.412h1.78a2.38 2.38 0 01.131-.781c.079-.205.22-.406.424-.6l.715-.667c.303-.295.523-.583.66-.865.137-.282.206-.596.206-.94 0-.789-.254-1.397-.763-1.824-.508-.428-1.225-.642-2.15-.642-.93 0-1.653.232-2.167.695-.515.462-.776 1.109-.785 1.939h2.105c.008-.311.089-.558.242-.741a.75.75 0 01.604-.274c.54 0 .81.313.81.94 0 .257-.08.493-.24.707-.16.213-.393.449-.7.706-.308.258-.53.562-.667.912-.137.351-.205.83-.205 1.435zm-.255 1.893c0 .307.11.56.333.756.222.197.499.296.83.296.333 0 .61-.099.832-.296a.966.966 0 00.333-.756.966.966 0 00-.333-.756 1.206 1.206 0 00-.831-.296c-.332 0-.61.098-.831.296a.966.966 0 00-.333.756z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}

export default SvgTooltip;